<template>
    <div>
        <section id="login-header">
            <div class="container-fluid">
                <!-- <template v-if="header === 'login-header'">
                    <LoginHeader />
                </template> -->
                <!-- <template v-else>
                    <NormalHeader />
                </template> -->
            </div>
        </section>

        <slot />
    </div>
</template>

<script>
import NormalHeader from "../components/NormalHeader";
import LoginHeader from "../components/LoginHeader";

export default {
    name: "NoProgress",
    components: {
        NormalHeader,
        LoginHeader,
    },
    computed: {
        header() {
            return (this.$route.meta.header || "normal") + "-header";
        },
    }
}
</script>